import { IMaskInput } from "react-imask";
 

interface MaskInputProps {
  mask: string | any;
  value: string;
  onChange: (value: string) => void;
  onKeyPress?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  type?: string;
  autoComplete?: string;
  ariaRequired?: boolean;
  ariaInvalid?: boolean ;
  ariaErrormessage?: string;
}

export default function MaskInput({
  mask,
  value,
  onChange,
  onKeyPress,
  onBlur,
  onFocus,
  placeholder,
  className,
  id,
  type = "text",
  autoComplete = "off",
  ariaRequired,
  ariaInvalid,
  ariaErrormessage
}: MaskInputProps) {
  return (
    <IMaskInput
      mask={mask}
      lazy={false}
      placeholderChar={placeholder}
      overwrite={true}
      value={value}     
      className={className}
      id={id}
      type={type}
      autoComplete={autoComplete}
      aria-required={ariaRequired}
      aria-invalid={!!ariaInvalid}
      aria-errormessage={ariaErrormessage}
      // IMPORTANT: IMask uses onAccept instead of onChange
      onAccept={(val) => onChange(val)}
      onKeyPress={onKeyPress}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
}
